
@if (!clientChore.errorText) {
  <div>
    {{ clientChore.status | titlecase }}
  </div>
}
@if (clientChore.errorText) {
  <div>
    @if (clientChore.errorText) {
      <a
        [href]="'#error'"
        class="failed"
        placement="bottom"
        container="body"
        (click)="onNoteClick($event)"
        [ngbPopover]="clientChore.errorText">
        {{ clientChore.status | titlecase }}
      </a>
    }
  </div>
}

@if (clientChore.currentStep && !clientChore.ended) {
  <div class="step-progress">
    @if (clientChore.currentStepNumber) {
      <div>
        Step {{ clientChore.currentStepNumber}} of {{ clientChore.totalSteps }}:
      </div>
    }
    @if (!clientChore.currentStepNumber) {
      <div>
        Step:
      </div>
    }
    {{ clientChore.currentStepDisplayName }}
    @if (clientChore.currentStepPercentage > 0) {
      <span>
        ({{ clientChore.currentStepPercentage }}%)
      </span>
    }
  </div>
}
